import { FC, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { State } from 'redux/initialState';

import Page from 'modules/_shared/components/Pages/Page';
import BoardDetailsHeader from 'modules/_shared/components/BoardDetailsHeader';
import BoardDetailsInfoCard from 'modules/_shared/components/BoardDetailsInfoCard';
import { Board } from 'types';
import { boardEntityTypes } from 'modules/_shared/components/BoardsListHeader/constants/boardEntityTypes';
import BoardDetailsDocumentsCard from 'modules/_shared/components/BoardDetailsDocumentsCard';

import { useGetMenu } from 'modules/administratives/hooks/useGetMenu';
import { useGetActualSociety } from 'hooks/useGetActualSociety';
import menuTypes from 'constants/menuTypes';

const BasicBoardDetails: FC = () => {
  const { societyId, boardId } = useParams();

  const boards = useSelector((state: State) => state.boards);

  const board = useMemo(
    () => boards.find((board) => board._id === boardId),
    [boardId, boards]
  );

  const actualSociety = useSelector(
    (state: State) => state.society?.actualSociety
  );

  useGetMenu(menuTypes.NULL);
  useGetActualSociety(societyId);

  return (
    <Page className="bg-lighter pb-5">
      <BoardDetailsHeader board={board} society={actualSociety} />

      <div className="row">
        <div className="col-12 col-xl-5">
          <BoardDetailsInfoCard
            board={board as Board}
            boardType={boardEntityTypes.BASIC_BOARD}
          />
        </div>

        <div className="col-12 col-xl-7">
          {board?.entityType === boardEntityTypes.COUNCIL ? (
            <>
              {/*  <CouncilMembersDocumentsCard
               council={council as Council}
               documents={documents}
               society={actualSociety}
             /> */}
            </>
          ) : (
            <BoardDetailsDocumentsCard
              boardId={boardId}
              boardDocumentsIds={board?.attachedDocuments || []}
              boardType={boardEntityTypes.BASIC_BOARD}
            />
          )}
        </div>
      </div>
    </Page>
  );
};

export default BasicBoardDetails;
